import Loadable from 'react-loadable';

export const Drawers = Loadable({
  loader: () => import(/* webpackChunkName: "AtlasDrawers" */ './drawers'),
  loading: () => null,
});
